import { createContext, Dispatch, FC, ReactNode, useContext, useReducer } from "react";
import { User } from "../types";
import { authInitialState, AuthReducer } from "../state/reducers/authReducers";
import { AuthActions } from "../state/actions/authActions";

export const AuthStateContext=createContext<User>(authInitialState);
export const AuthDispacthContext=createContext<Dispatch<AuthActions>>(()=>undefined);

interface AuthProviderProps{
    children:ReactNode
}

export const AuthProvider:FC<AuthProviderProps>=({children})=>{
    const [user,dispatch]=useReducer(AuthReducer,authInitialState);
    return(
        <AuthStateContext.Provider value={user}>
            <AuthDispacthContext.Provider value={dispatch}>
                {children}
            </AuthDispacthContext.Provider>
        </AuthStateContext.Provider>
    );    
};

export const useAuthState=()=>{
    const context=useContext(AuthStateContext);

    if  (context===undefined) {
        throw new Error("useAuthState mut be used within an AuthProvider")
    }
    return context;
}


export const useAuthDispatch=()=>{
    const context=useContext(AuthDispacthContext);

    if  (context===undefined) {
        throw new Error("useAuthDispatch mut be used within an AuthProvider")
    }
    return context;
}